import { toast } from "react-toastify";
import Loader from "./Loader";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { clearCache } from "../../utils";

interface Props {
    title: string;
    id: string;
    query: string;
    cacheName?: string;
    onDeleteAction?: () => void;
    onDeleteError?: (errors: { errorCode: string | number; message: string }) => void;
}

const Delete = ({ title, id, query, cacheName, onDeleteAction, onDeleteError }: Props) => {
    const { submitMutation, loading } = useGlobalMutation(
        query,
        (cache: any) => {
            cacheName && clearCache(cache, cacheName);
        },
        onDeleteError
    );

    const submitAction = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const deleteConfirm = e.currentTarget.deleteConfirm.value;
        const ID = e.currentTarget.deleteID.value;
        const variables = {
            id: ID,
        };

        if (ID && deleteConfirm.toLocaleLowerCase() === "confirm") {
            try {
                await submitMutation(
                    variables,
                    "deleteAbbvieProEmbedJsSnippetById.abbvieProEmbedJsSnippet",
                    "Delete successfully"
                );
            } catch (error) {
                toast.error(error.message);
            }
        } else {
            toast.warn("Please enter CONFIRM to delete");
        }
    };

    return (
        <div className="positon-relative row no-gutters">
            <div className="col-lg-7">
                {loading && <Loader />}
                <div className="cmp-delete">
                    <h5 className="mb-3">
                        Are you sure you want to delete this {title}?
                        <br />
                        If YES then enter CONFIRM into the box.
                    </h5>

                    <form
                        className="d-flex flex-column align-items-start"
                        onSubmit={(e) => {
                            submitAction(e);
                        }}
                    >
                        <div className="form-group mb-3">
                            <input
                                name="deleteConfirm"
                                type="text"
                                className="form-control mb-0"
                                placeholder="Type CONFIRM"
                            />
                            <input name="deleteID" type="hidden" value={id} />
                        </div>
                        <button type="submit" className="btn btn-danger">
                            Delete {title}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Delete;
